<template>
  <div>
    <span
      :id="`popover-edit-btn${id}`"
      class="text-warning rounded-circle"
      data-placement="left"
      data-html="true"
      data-toggle="popover"
      data-trigger="hover"
      :data-content="`${message_edited}`"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-exclamation-circle"
        viewBox="0 0 16 16"
      >
        <path
          d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
        />
        <path
          d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"
        />
      </svg>
    </span>
    <div :id="`popover-edit-target${id}`" class="popover popover-x popover-default">
      <div class="arrow"></div>
      <div class="popover-content">
        <p class="mb-0 p-2">{{ message_edited }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import $ from 'jquery'

export default {
  name: 'PopoverMessageEdit',
  props: {
    id: {
      type: String,
      required: true
    },
    message_edited: {
      type: String,
      required: true
    }
  },
  mounted: function () {
    const popoverBtn = $(`#popover-edit-btn${this.id}`)
    popoverBtn.popover({
      target: `#popover-edit-target${this.id}`,
      trigger: 'hover'
    })
  }
}
</script>
